import { PeriodProvider } from "@/providers/Period";
import { ChartLineUpIcon } from "@phosphor-icons/react";
import { lazy } from "react";

const EntradasDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.EntradasDashboard })));
const GestaoRecebimento = lazy(() => import("./GestaoRecebimento"));
const Operacional = lazy(() => import("./Operacional"));
const RelatorioRecebimento = lazy(() => import("./RelatorioRecebimento"));

const Module = {
  menuItem: {
    to: "/entradas",
    title: "Entradas",
    icon: ChartLineUpIcon,
    id: 0,
    childrens: [
      {
        to: "entradas/dash",
        title: "Dashboard",
        fullTitle: "Dashboard",
        id: 18,
      },
      {
        to: "/entradas/gestao-de-recebimento",
        title: "Gestao",
        fullTitle: "Gestao de Recebimento",
        id: 19,
      },
      {
        to: "/entradas/operacional",
        title: "Operacional",
        fullTitle: "Operacional",
        id: 20,
      },
      {
        to: "/entradas/relatorio-recebimento",
        title: "Relatorio de Recebimento",
        fullTitle: "Relatorio de Recebimento",
        id: 21,
      },
    ],
  },

  routes: [
    {
      path: "/entradas/gestao-de-recebimento",
      element: (
        <PeriodProvider>
          <GestaoRecebimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/entradas/operacional",
      element: (
        <PeriodProvider>
          <Operacional />
        </PeriodProvider>
      ),
    },
    {
      path: "/entradas/relatorio-recebimento",
      element: <RelatorioRecebimento />,
    },
    {
      path: "entradas/dash",
      element: (
        <PeriodProvider>
          <EntradasDashboard />
        </PeriodProvider>
      ),
    },
  ],
};

export default Module;
